(function () {
  // ---------- Announcement bar rotation ----------
  const track = document.querySelector('[data-fc-announce]');
  if (track) {
    let messages;
    try { messages = JSON.parse(track.dataset.messages || '[]'); } catch (e) { messages = []; }

    // Scale USD threshold amounts (e.g. "$100") to the active presentment
    // currency using the shared fluffcoMoney helper so every section formats
    // the same way (proper Intl symbol, locale-aware grouping).
    (function () {
      var fmt = window.fluffcoMoney;
      if (!fmt) return;
      messages = messages.map(function (m) {
        var h = m.highlight && m.highlight.match(/^\$(\d+)$/)
          ? fmt(parseInt(RegExp.$1, 10))
          : m.highlight;
        var t = m.text && m.text.match(/\$(\d+)/)
          ? m.text.replace(/\$(\d+)/, function (_, n) { return fmt(parseInt(n, 10)); })
          : m.text;
        return { text: t, highlight: h, suffix: m.suffix };
      });
    })();
    if (messages.length > 1) {
      let i = 0;
      const render = (m) => {
        const t = document.createTextNode(m.text || '');
        const h = document.createElement('span');
        h.className = 'fc-announce__highlight';
        h.textContent = m.highlight || '';
        const s = document.createTextNode(m.suffix || '');
        track.innerHTML = '';
        track.appendChild(t);
        track.appendChild(h);
        track.appendChild(s);
      };
      setInterval(() => {
        track.setAttribute('data-fading', 'true');
        setTimeout(() => {
          i = (i + 1) % messages.length;
          render(messages[i]);
          track.setAttribute('data-fading', 'false');
        }, 350);
      }, 3500);
    }
  }

  // ---------- FlashSaleBanner countdown ----------
  const flash = document.querySelector('[data-fc-flash]');
  if (flash) {
    const hrsEl = flash.querySelector('[data-fc-flash-hrs]');
    const minEl = flash.querySelector('[data-fc-flash-min]');
    const secEl = flash.querySelector('[data-fc-flash-sec]');
    const closeBtn = flash.querySelector('[data-fc-flash-close]');
    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      const diff = midnight.getTime() - now.getTime();
      if (diff <= 0) {
        flash.setAttribute('data-dismissed', 'true');
        syncHeaderBottom();
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      const hrs = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;
      if (hrsEl) hrsEl.textContent = pad(hrs);
      if (minEl) minEl.textContent = pad(mins);
      if (secEl) secEl.textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        flash.setAttribute('data-dismissed', 'true');
        syncHeaderBottom();
      });
    }
  }

  // ---------- Sync mobile drawer's top to header bottom ----------
  const header = document.querySelector('.fc-header');
  function syncHeaderBottom() {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--fc-header-bottom', rect.bottom + 'px');
  }
  syncHeaderBottom();
  window.addEventListener('resize', syncHeaderBottom);
  window.addEventListener('scroll', syncHeaderBottom, { passive: true });

  // ---------- Mega menu hover + click (desktop) ----------
  document.querySelectorAll('[data-fc-megatrigger]').forEach((trigger) => {
    const targetId = trigger.dataset.fcMegatrigger;
    const target = document.getElementById(targetId);
    if (!target) return;
    let timer;
    const open = () => {
      clearTimeout(timer);
      target.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
    };
    const closeSoon = () => {
      timer = setTimeout(() => {
        target.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      }, 150);
    };
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', closeSoon);
    target.addEventListener('mouseenter', open);
    target.addEventListener('mouseleave', closeSoon);
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = target.getAttribute('data-open') === 'true';
      if (isOpen) {
        target.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        open();
      }
    });
  });

  // ---------- Mobile drawer toggle ----------
  const drawer = document.querySelector('[data-fc-drawer]');
  const openBtn = document.querySelector('[data-fc-drawer-open]');
  if (drawer && openBtn) {
    openBtn.addEventListener('click', () => {
      syncHeaderBottom();
      const isOpen = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', isOpen ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      openBtn.setAttribute('aria-label', isOpen ? 'Menu' : 'Close menu');
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
  }

  // ---------- Mobile Shop accordion ----------
  const shopBtn = document.querySelector('[data-fc-mobile-shop]');
  const shopContent = document.querySelector('[data-fc-mobile-shop-content]');
  if (shopBtn && shopContent) {
    shopBtn.addEventListener('click', () => {
      const isOpen = shopBtn.getAttribute('aria-expanded') === 'true';
      shopBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      shopContent.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }

  // ---------- Country/currency dropdown (desktop) ----------
  const countryToggle  = document.querySelector('[data-fc-country-toggle]');
  const countryDropdown = document.querySelector('[data-fc-country-dropdown]');
  if (countryToggle && countryDropdown) {
    countryToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = countryToggle.getAttribute('aria-expanded') === 'true';
      countryToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      countryDropdown.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!countryToggle.contains(e.target) && !countryDropdown.contains(e.target)) {
        countryToggle.setAttribute('aria-expanded', 'false');
        countryDropdown.setAttribute('aria-hidden', 'true');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        countryToggle.setAttribute('aria-expanded', 'false');
        countryDropdown.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // ---------- GeoIP auto-switch ----------
  // Uses Shopify's built-in browsing context endpoint — no external API needed.
  // Only fires once per session and only if the user hasn't already chosen manually.
  const GEO_PREF_KEY = 'fc_country_set';
  if (!sessionStorage.getItem(GEO_PREF_KEY) && localStorage.getItem(GEO_PREF_KEY) !== 'manual') {
    // Mark that we've run geo-detection this session so it doesn't re-fire
    sessionStorage.setItem(GEO_PREF_KEY, '1');
    fetch('/browsing_context_suggestions.json')
      .then((r) => r.json())
      .then((data) => {
        const detected = data && data.detected_values && data.detected_values.country
          ? data.detected_values.country.handle
          : null;
        if (!detected) return;
        // Current country is embedded by Liquid into a data attribute on the toggle
        const current = countryToggle ? countryToggle.getAttribute('data-current-country') : null;
        if (current && detected.toUpperCase() === current.toUpperCase()) return;
        // Find a localization form whose country_code matches the detected country
        const matchingForm = document.querySelector(
          `.fc-country-dropdown form input[value="${detected.toUpperCase()}"]`
        );
        if (matchingForm) {
          matchingForm.closest('form').submit();
        }
      })
      .catch(() => {}); // silently ignore — geo is best-effort
  }

  // Mark a manual selection so GeoIP doesn't override it next session
  if (countryDropdown) {
    countryDropdown.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', () => {
        sessionStorage.setItem(GEO_PREF_KEY, 'manual');
        localStorage.setItem(GEO_PREF_KEY, 'manual');
      });
    });
  }

  // ---------- Account dropdown ----------
  const accountToggle = document.querySelector('[data-fc-account-toggle]');
  const accountDropdown = document.querySelector('[data-fc-account-dropdown]');
  if (accountToggle && accountDropdown) {
    accountToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = accountToggle.getAttribute('aria-expanded') === 'true';
      accountToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      accountDropdown.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!accountToggle.contains(e.target) && !accountDropdown.contains(e.target)) {
        accountToggle.setAttribute('aria-expanded', 'false');
        accountDropdown.setAttribute('aria-hidden', 'true');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        accountToggle.setAttribute('aria-expanded', 'false');
        accountDropdown.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // ---------- Mobile Country accordion ----------
  const countryBtn = document.querySelector('[data-fc-mobile-country]');
  const countryList = document.querySelector('[data-fc-mobile-country-list]');
  if (countryBtn && countryList) {
    countryBtn.addEventListener('click', () => {
      const isOpen = countryBtn.getAttribute('aria-expanded') === 'true';
      countryBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      countryList.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }
})();
